<script lang="ts">
  interface Props {
    checked: boolean;
    label: string;
    onchange: (checked: boolean) => void;
    disabled?: boolean;
  }

  let { checked, label, onchange, disabled = false }: Props = $props();
</script>

<!--
  A checkbox, not a switch: the mockup draws a square that fills in, and the two
  controls answer different questions. A switch turns a setting on now; a
  checkbox states an intention that takes effect when the form is submitted,
  which is exactly what "recordarme" is.

  Native semantics via `role="checkbox"` on a button, so Space, focus and the
  announced state come from the platform rather than from this file.
-->
<button
  type="button"
  class="checkbox"
  role="checkbox"
  aria-checked={checked}
  {disabled}
  onclick={() => onchange(!checked)}
>
  <span class="checkbox__box" class:checkbox__box--on={checked} aria-hidden="true"></span>
  <span class="checkbox__label">{label}</span>
</button>
